import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import mousetrap from 'mousetrap';
import { Link, withRouter } from 'react-router-dom';


class Nav extends Component {
  constructor (props) {
    super(props);
    this.state = {
      prevUrl: null,
      nextUrl: null,
    };
    this.handleLeftArrow = this.handleLeftArrow.bind(this);
    this.handleRightArrow = this.handleRightArrow.bind(this);
    this.setUrls = this.setUrls.bind(this);
  }

  componentDidMount () {
    this.setUrls();
    mousetrap.bind(['left'], this.handleLeftArrow);
    mousetrap.bind(['right'], this.handleRightArrow);
  }

  componentDidUpdate (prevProps, prevState) {
    const { activeEra, activeSlideIndex } = this.props;
    if (activeEra !== prevProps.activeEra || activeSlideIndex !== prevProps.activeSlideIndex) {
      this.setUrls();
    }
  }

  componentWillUnmount () {
    mousetrap.unbind(['left', 'right']);
  }

  handleLeftArrow () {
    const { history } = this.props;
    const { prevUrl } = this.state;
    prevUrl && history.push(prevUrl);
  }

  handleRightArrow () {
    const { history } = this.props;
    const { nextUrl } = this.state;
    nextUrl && history.push(nextUrl);
  }

  setUrls () {
    const { match, activeEra, activeSlideIndex, slideData: { slides } } = this.props;
    const urlSlideIndex = activeSlideIndex + 1;
    const baseUrl = `${match.url}${activeEra ? '/' + activeEra : ''}`;
    const prevUrl = urlSlideIndex > 1 ? `${baseUrl}/${urlSlideIndex - 1}` : null;
    const nextUrl = urlSlideIndex < slides.length ? `${baseUrl}/${urlSlideIndex + 1}` : null;
    this.setState({ prevUrl, nextUrl });
  }

  render () {
    const { prevUrl, nextUrl } = this.state;
    // TODO: i18n hardcoded strings
    return [
      prevUrl
        ? <Link key="next-prev-nav-prev" to={prevUrl} className="next-prev-nav-prev"><div><span>Prev</span></div></Link>
        : <a key="next-prev-nav-prev" className="next-prev-nav-prev disabled"><div><span>Prev</span></div></a>,
      nextUrl
        ? <Link key="next-prev-nav-next" to={nextUrl} className="next-prev-nav-next"><div><span>Next</span></div></Link>
        : <a key="next-prev-nav-next" className="next-prev-nav-next disabled"><div><span>Next</span></div></a>,
    ];
  }
}

Nav.propTypes = {
  titleId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ titles }, ownProps) => ({
  ...titles[ownProps.titleId],
});

export default withRouter(connect(mapStateToProps)(Nav));



// WEBPACK FOOTER //
// ./src/components/Timeline/Nav.js